module.exports = __webpack_public_path__ + "media/3_6-6.4ca41c44.mp3";